export default __webpack_public_path__ + "static/media/slider_bg_rotated.af354824.png";